// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".green-text[data-v-1bb73ae6]{color:green}", "",{"version":3,"sources":["webpack://./resources/js/Components/Settings/SmsClientsSettings/Form.vue"],"names":[],"mappings":"AACI,6BACI,WAAA","sourcesContent":["\n    .green-text {\n        color: green;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
